import React, { Component } from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as AppActions from "../../actions";
import { Loader, Button, Select, TextArea, Icon } from "semantic-ui-react";
import { Form } from "semantic-ui-react";
import { TitleCase } from "../../common";
import DatePicker from "react-datepicker";
import moment from "moment";
import ReactModal from "react-modal";
import "react-datepicker/dist/react-datepicker.css";

const formatUser = user => user ? `${user.user_title} ${user.user_firstname} ${user.user_lastname}` : ''

const customStylesTaskEditor = {
    content: {
      top: "50%",
      width: "85%",
      maxWidth: "400px",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      padding: "0px",
      borderRadius: "5px",
      border: "0px",
      height: "700px",
      maxHeight: "95%",
      backgroundColor: "#fff",
      transform: "translate(-50%, -50%)"
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)"
    }
};

class TaskEditor extends Component {
    state = {
        id: null,
        title: "",
        status: "open",
        priority: "low",
        note: "",
        due: moment(),
        recipientId: null,
        error: false,
        errorMessage: "",
        submitted: false
    };

    componentDidMount() {
        this.props.actions.getUserList();
        const { task, formId } = this.props;
        if (task) {
            this.setState({                
                id: task.task_id,
                title: task.task_title,
                status: task.task_status,
                priority: task.task_priority,
                note: task.task_note,
                due: moment(task.task_due),
                recipientId: task.recipient_id,
            })
        }
    }

    statusOptions = [
        { key: 'open', value: 'open', text: 'Open' },
        { key: 'in-progress', value: 'in-progress', text: 'In Progress' },
        { key: 'deferred', value: 'deferred', text: 'Deferred' },
        { key: 'complete', value: 'complete', text: 'Complete' }
    ]

    priorityOptions = [
        { key: 'low', value: 'low', text: 'Low' },
        { key: 'medium', value: 'medium', text: 'Medium' },
        { key: 'high', value: 'high', text: 'High' }
    ]

    userSelectItem = user => ({ key: user.user_id, value: user.user_id, text: formatUser(user) })

    updateInputValue = e => {
        let change = {};
        change[e.target.id] = e.target.value;
        this.setState(change);
    }

    updateSelectValue = (e, d) => {
        var change = {};
        change[d.id] = d.value;
        this.setState(change);
    }

    updateDue = date => {
        this.setState({ due: date })
    }


    onSave = () => {
        const { id, title, status, priority, note, due, recipientId } = this.state
        const task = {
            task_title: title,
            task_status: status,
            task_priority: priority,
            task_note: note,
            task_due: due,
            recipient_id: recipientId,
            form_id: this.props.formId,
            ...(id ? { task_id: id } : {})
        }
        const { createTask, updateTask } = this.props.actions;
        const action = task.task_id ? updateTask : createTask
        action(task)
        this.props.onClose();
      }

    renderError() {
        if (
            (this.state.error && !this.state.submitted) ||
            (this.state.submitted && this.state.errorMessage !== "")
        )
            return (
                <div
                    style={{
                        textAlign: "center",
                        width: "100%",
                        position: "relative",
                        top: "-10px",
                        marginBottom: 10,
                        fontSize: 12,
                        color: "rgb(255, 51, 51)"
                    }}
                >
                    {this.state.errorMessage}
                </div>
            );

        return <div></div>;
    }

    renderEditor() {
        if (this.props.isLoading) {
            return (
                <div>
                    <br />
                    <br />
                    <br />
                    <Loader
                        active
                        size="large"
                        style={{ color: "#33ae8b" }}
                        inline="centered"
                    ></Loader>
                </div>
            );
        }

        const userOptions = this.props.users.data ? this.props.users.data.map(this.userSelectItem) : [];

        return (
            <form onSubmit={this.onSave}>
                <div style={{ width: "100%" }} className="ui form">
                    <Form.Field>
                        {this.renderError()}
                        <label style={{ fontWeight: "bold", fontSize: "15px" }}>
                            {TitleCase("Task Title")}
                        </label>
                        <div>
                            <input
                                autoFocus
                                style={{ width: "100%" }}
                                type="text"
                                required
                                value={this.state.title}
                                id="title"
                                onChange={e => this.updateInputValue(e)}
                            />
                        </div>
                        <br />
                        <label style={{ fontWeight: "bold", fontSize: "15px" }}>
                            {TitleCase("Status")}
                        </label>
                        <div>
                            <Select
                                style={{ width: "100%" }}
                                value={this.state.status}
                                placeholder="Select"
                                onChange={(e, d) => this.updateSelectValue(e, d)}
                                options={this.statusOptions}
                                id="status"
                            />
                        </div>
                        <br />
                        <label style={{ fontWeight: "bold", fontSize: "15px" }}>
                            {TitleCase("Priority")}
                        </label>
                        <div>
                            <Select
                                style={{ width: "100%" }}
                                value={this.state.priority}
                                placeholder="Priority"
                                onChange={(e, d) => this.updateSelectValue(e, d)}
                                options={this.priorityOptions}
                                id="priority"
                            />
                        </div>
                        <br />
                        <label style={{ fontWeight: "bold", fontSize: "15px" }}>
                            {TitleCase("Note")}
                        </label>
                        <div>
                            <TextArea
                                style={{ width: "100%" }}
                                rows={2}
                                placeholder='Note'
                                value={this.state.note}
                                id="note"
                                onChange={e => this.updateInputValue(e)}
                            />
                        </div>
                        <br />
                        <label style={{ fontWeight: "bold", fontSize: "15px" }}>
                            {TitleCase("Due")}
                        </label>
                        <div>
                            <DatePicker
                                style={{ width: "100%" }}
                                selected={this.state.due}
                                onChange={this.updateDue}
                                peekNextMonth
                                dateFormat="DD/MM/YYYY"
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                            />

                        </div>
                        <br />
                        <label style={{ fontWeight: "bold", fontSize: "15px" }}>
                            {TitleCase("Recipient")}
                        </label>
                        <div>
                            <Select
                                style={{ width: "100%" }}
                                value={this.state.recipientId}
                                placeholder="Recipient"
                                onChange={(e, d) => this.updateSelectValue(e, d)}
                                options={userOptions}
                                search
                                id="recipientId"
                            />
                        </div>
                        <br />
                        <div>
                            <Button
                                style={{ width: "100%" }}
                                active
                                className="ui button"
                                role="button"
                                type="submit"
                            >
                                Save
              </Button>
                        </div>
                    </Form.Field>
                </div>
            </form>
        );
    }

    render = () =>
        (<ReactModal
        isOpen={true}
        style={customStylesTaskEditor}
        contentLabel="Task"
      >
        <div
          style={{
            paddingTop: 40,
            backgroundColor: "white",
            paddingLeft: 0,
            paddingRight: 0,
            borderRadius: 6,
            width: "100%",
            height: "100%"
          }}
        >
          <Icon
            type="MaterialIcons"
            onClick={this.props.onClose}
            style={{
              position: "absolute",
              right: "20px",
              top: "20px",
              color: "#e6e6e6",
              cursor: "pointer"
            }}
            size="large"
            name="close"
          />
         {this.renderEditor()}
        </div>
      </ReactModal>)

}

TaskEditor.propTypes = {
    task: PropTypes.object,
    formId: PropTypes.number,
    onClose: PropTypes.func.isRequired,    
};

const mapStateToProps = state => ({
    users: state.users,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(AppActions, dispatch)
});

export default
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(TaskEditor)
    ;



// WEBPACK FOOTER //
// ./src/components/TaskEditor/index.js